module.exports = __webpack_public_path__ + "static/media/content-step2.1ff3ec4c.jpg";